import { EmailAssigneeOptions } from 'pages/Tasks/constants'
import { accountTypeTitleForName } from 'reducers/partyNames'

/** Mirrors backend HARDCODED_EMAILS_WITH_RECIPIENTS — emails with configurable automatic recipients. */
export const HARDCODED_EMAILS_WITH_RECIPIENTS = [
  'loan.borrowerDocumentsExpiring',
  'loan.documentSignRequest',
  'loan.outstandingSignatureReminder',
  'loan.drawRequest',
  'loan.mldsSignRequest',
  'loan.creditAuthorizationSignRequest',
  'loan.paymentForLoanSetupInstructions',
  'loan.fundDrawRequest',
  'loan.loanExceptionRequest',
  'loan.newLoanCreated',
  'loan.commercialLockExpiredNotice',
  'loan.scenarioSharing',
  'loan.contractorBuilderApprovalInvitation',
  'loan.contractorBuilderApplicationApproved',
  'loan.withdrawnDeclinedLoansWeeklyReports',
  'loan.transferLetter',
  'loan.servicingTransfer',
] as const

export function supportsHardcodedRecipients(key: string): boolean {
  return (HARDCODED_EMAILS_WITH_RECIPIENTS as readonly string[]).includes(key)
}

export const COMPANY_MAILBOX_OPTIONS: Record<string, string> = {
  'company.HOME_EMAIL': '[Company] Home Email',
  'company.CORP_EMAIL': '[Company] Corporate Email',
  'company.LOANSETUP_EMAIL': '[Company] Loan Setup Email',
  'company.UNDERWRITER_EMAIL': '[Company] Underwriter Email',
  'company.DISCLOSURE_EMAIL': '[Company] Disclosure Email',
  'company.CLOSE_EMAIL': '[Company] Closing Email',
  'company.PARTNER_EMAIL': '[Company] Partner Email',
  'company.LOCK_EMAIL': '[Company] Lock Email',
  'company.DRAW_EMAIL': '[Company] Draw Email',
  'company.ACCOUNTING_EMAIL': '[Company] Accounting Email',
  'company.INFO_EMAIL': '[Company] Info Email',
  'company.SERVICE_EMAIL': '[Company] Servicing Email',
  'company.CEO_EMAIL': '[Company] CEO Email',
}

export const CONTEXT_RECIPIENT_OPTIONS: Record<string, string> = {
  'context.signer': '[Context] Signer (Borrower / Co-Borrower / Member)',
  'context.contractor': '[Context] Contractor Email',
  'context.contractorCreator': '[Context] Contractor Creator',
  'context.scenarioEmail': '[Context] Scenario Email',
  'context.paymentRecipient': '[Context] Payment Recipient',
  'context.borrowerPortalUser': '[Context] Borrower Portal User',
  'context.creatorAccountExecutive': "[Context] Creator's Account Executive",
}

export const hardcodedEmailRecipientOptions = (): Record<string, string> => ({
  ...EmailAssigneeOptions(),
  ...COMPANY_MAILBOX_OPTIONS,
  ...CONTEXT_RECIPIENT_OPTIONS,
  'context.creatorAccountExecutive': `[Context] Creator's ${accountTypeTitleForName('Account Executive')}`,
})
